var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 6C14.25 9.31607 11.9016 12 9 12C6.09844 12 3.75 9.31607 3.75 6C3.75 2.68393 6.09844 0 9 0C11.9016 0 14.25 2.68393 14.25 6ZM10.1523 14.4638C9.77734 14.5341 9.39275 14.5714 9 14.5714C7.84687 14.5714 6.76875 14.25 5.78906 13.7143H5.4C2.41875 13.7143 0 16.4786 0 19.8857V21.4286C0 22.8482 1.00781 24 2.25 24L15 24L15.75 24C16.0963 24 16.4245 23.9105 16.7176 23.7505C19.1943 23.0119 21 20.7168 21 18C21 14.6863 18.3137 12 15 12C13.0085 12 11.2436 12.9702 10.1523 14.4638ZM15 23C17.7614 23 20 20.7614 20 18C20 15.2386 17.7614 13 15 13C12.2386 13 10 15.2386 10 18C10 20.7614 12.2386 23 15 23ZM16.9091 15L12.8182 19.0909L13.9091 20.1818L18 16.0909L16.9091 15ZM12.5455 19.3636L12 21L13.6364 20.4546L12.5455 19.3636Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditUser);
export default __webpack_public_path__ + "static/media/EditUser.c3fa90b33ccbef3982426bb667e1c645.svg";
export { ForwardRef as ReactComponent };